module.exports = __webpack_public_path__ + "static/media/app-icon.214acb2c.svg";